import React, { useState, useRef, useEffect } from "react";
import about from "../../assets/image/about_nha_pg_logo.png";
import {
  MobileOTPServices,
  mobileOtpVerifyServices,
  EncryptServices
} from "../../services";
import { useSelector } from "react-redux";
import { timerCount } from "../../config";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const LoginMobileOtpVerify = ({
  setMobileOtp,
  setIsVerifiedOtp,
  mobileNumber,
  setMobileOTPSent,
  setCurrentStep
}) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [otpGuid, setOtpGuid] = useState("");
  const [displayMobileNumber, setDisplayMobileNumber] = useState("");
  const [timer, setTimer] = useState(timerCount);
  const [resendCount, setResendCount] = useState(2);
  const [disableResend, setDisableResend] = useState(false);
  // const sendMobileNumber = useSelector((state) => state.user.mobileNumber);
  const uuid = useSelector((state) => state.user.UUid);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (mobileNumber) {
      setDisplayMobileNumber(mobileNumber);
    }
    const savedResponse = localStorage.getItem("otpResponse");
    console.log(savedResponse,'saved resp');
    
    if (savedResponse) {
      try {
        const response = JSON.parse(savedResponse);
        const guid = response?.data.otpGuid;
        if (guid) {
          setOtpGuid(guid);
        } else {
          setError("No valid OTP session found. Please resend OTP.");
        }
      } catch (error) {
        setError("Failed to load OTP session. Please resend OTP.");
      }
    } else {
      setError("No OTP session found. Please resend OTP.");
    }
  }, [mobileNumber]);

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(countdown);
  }, [timer]);

  const sendMobileNumber = localStorage.getItem("mobile");
  // console.log("resssssend 6666count", resendCount);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("");

    if (otpValue.length !== 6) {
      setError("Please enter a valid 6-digit OTP.");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const verificationResponse = await VerifymobileOtp(otpValue);
      console.log(verificationResponse, "===");

      const statusCode = verificationResponse?.data?.statusCode;
      const statusMessage = verificationResponse?.message;

      if (verificationResponse?.success === true ) {
        const patientDetails = verificationResponse.data?.patients;

        if (patientDetails && Array.isArray(patientDetails)) {
          localStorage.setItem(
            "patientDetails",
            JSON.stringify(patientDetails)
          );
        } else {
          localStorage.setItem("patientDetails", JSON.stringify([]));
          Swal.fire({
            title: patientDetails?.length === 0 ? "No Profile Found" : "",
            text: "Do you want to continue to create profile and Link ABHA?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!"
          }).then((result) => {
            if (result.isConfirmed) {
              setCurrentStep("SendAdharOTP");
            }
          });
        }
        // setIsVerifiedOtp(true);
        // setMobileOTPSent(true);
        setCurrentStep("PatientList");
        // setMobileOtp(false);
        localStorage.removeItem("otpResponse");
        setError(null);
      } else {
        // OTP is invalid or other error
        toast.error(statusMessage || "OTP verification failed");
        // setIsVerifiedOtp(false);
        // setMobileOtp(true);
      }
    } catch (error) {
      console.log(error, "error1");
      setError("Verification failed. Please enter correct otp.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        // Changed to 5 for 6-digit OTP
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const VerifymobileOtp = async (otpValue) => {
    try {
      const body = {
        guid: uuid,
        otp: otpValue
      };
      return await mobileOtpVerifyServices({ body });
    } catch (error) {
      console.error("Error while verifying OTP:", error);
      throw error;
    }
  };

  const sendOtp = async () => {
    if (resendCount <= 0 || disableResend) {
      setDisableResend(true);
      setError("You have reached the maximum resend attempts.");
      return;
    }

    setIsLoading(true);
    setError(null);
    const mobile = localStorage.getItem("mobile");

    try {
      const emobile = await EncryptServices({
        headers: {},
        body: { data: mobile }
      });

      const body = {
        mobile: emobile,
        resent_count: resendCount
      };

      const response = await MobileOTPServices({ body });
      console.log("OTP Send Response:", response);

      if (response?.success) {
        const otpData = response.data;

        if (otpData?.otpGuid) {
          setOtpGuid(otpData.otpGuid);
          localStorage.setItem("otpResponse", JSON.stringify(response));
          setOtp(["", "", "", "", "", ""]);

          setResendCount((prev) => {
            const newCount = prev - 1;

            if (otpData.resent_count === 0 || newCount <= 0) {
              setDisableResend(true);
              toast.error("You have reached the maximum resend attempts.");
            } else {
              toast.success(
                `OTP sent successfully! Attempts left: ${newCount}`
              );
            }

            return newCount;
          });

          setTimeout(() => setError(null), 5000);
        } else {
          toast.error("OTP sent but technical error occurred");
          localStorage.removeItem("otpResponse");
        }
      } else {
        const errorMessage =
          response.data?.statusMessage || "Failed to send OTP";
        setError(errorMessage);

        if (response.data?.statusCode === "1") {
          setOtpGuid("");
          localStorage.removeItem("otpResponse");
        }
      }

      setTimer(timerCount);
    } catch (error) {
      console.log("Send OTP error:", error);
      setError("Failed to send OTP. Please try again.");
      localStorage.removeItem("otpResponse");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA and store all your medical records in one place.
                  Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA .
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA .</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-card content">
                <h3>Create / Link Your ABHA</h3>
                <p className="pt-4">
                  Enter OTP received on your number +91 {sendMobileNumber}
                </p>
                {error && (
                  <div
                    className={`alert ${
                      error.includes("successfully")
                        ? "alert-success"
                        : "alert-danger"
                    }`}
                  >
                    {error}
                  </div>
                )}
                <form onSubmit={handleSubmit} className="pt-4">
                  <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                    <div className="row otp-box-custom-row">
                      {otp.map((digit, index) => (
                        <div
                          key={index}
                          className="col-4 col-sm-3 col-md-2"
                          // className="col-ms-2 col-lg-2 col-xl-2 col-sm-2 col-xs-2"
                        >
                          <input
                            type="text"
                            maxLength="1"
                            placeholder="0"
                            autoComplete="off"
                            value={digit}
                            ref={(el) => (inputRefs.current[index] = el)}
                            onChange={(e) => handleInputChange(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            className="mobile-input otp otp-box-custom"
                            disabled={isLoading}
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  <button
                    type="submit"
                    className={`continue-btn ${
                      isLoading || otp.join("").length !== 6 ? "bg-disable" : ""
                    }`}
                    disabled={isLoading || otp.join("").length !== 6}
                  >
                    {isLoading ? "Verifying..." : "Continue"}
                  </button>

                  <p className="pt-2">
                    Didn't receive OTP to your number?{" "}
                    {!disableResend && resendCount > 0 && timer > 0 ? (
                      <span className="resend-timer">Resend in {timer}s</span>
                    ) : (
                      <button
                        type="button"
                        className={`resend-otp btn-link ${
                          disableResend ? "resend-diasbled-message" : ""
                        }`}
                        onClick={sendOtp}
                        disabled={isLoading || disableResend}
                      >
                        Resend OTP
                      </button>
                    )}
                  </p>

                  {!disableResend && resendCount > 0 && (
                    <p className="resend-message small">
                      You have {resendCount} resend attempt
                      {resendCount > 1 ? "s" : ""} left.
                    </p>
                  )}
                  {disableResend && (
                    <p className="text-danger small">
                      You have no resend attempts left.
                    </p>
                  )}
                </form>
                <div className="nha-logo-container">
                  <span>APPROVED BY NHA</span>
                  <img src={about} alt="NHA Logo" className="nha-logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LoginMobileOtpVerify;
